/**
 * event helper
 * @module event-helper
 */

var eventHelper = (function() {
  var addEvent = function(el, type, handler) {
    if (el.attachEvent) el.attachEvent('on' + type, handler);
    else el.addEventListener(type, handler);
  };

  var removeEvent = function(el, type, handler) {
    if (el.detachEvent) el.detachEvent('on' + type, handler);
    else el.removeEventListener(type, handler);
  };

  return {
    addEvent: addEvent,
    removeEvent: removeEvent
  };
})();

module.exports = eventHelper;



// WEBPACK FOOTER //
// ./helpers/event-helper.js